import { useState } from "react";
import { trackShare } from "interfaces/invite";

export default function ShareView() {
    const [copied, setCopied] = useState(false);
    const shareUrl = 'https://duckflow.io/?utm_source=app_share';

    const [friendEmail, setFriendEmail] = useState("");
    const [sending, setSending] = useState(false);

    const onInviteByEmail = async () => {
        if (!friendEmail) return;
        setSending(true);
        // Track the invite
        await trackShare({ platform: 'email', email: friendEmail }).catch((): null => null);
        // Open user's mail client with prefilled subject/body
        const subject = encodeURIComponent("Join me on DuckFlow");
        const body = encodeURIComponent(`Hey, I thought you might like DuckFlow: ${shareUrl}\n\nSign up here: ${shareUrl}`);
        window.location.href = `mailto:${friendEmail}?subject=${subject}&body=${body}`;
        setSending(false);
        setFriendEmail("");
    };

    const copyLink = async () => {
        await navigator.clipboard.writeText(shareUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className="min-h-screen bg-canvas font-sans">
            <div className="mx-auto max-w-3xl px-4 py-8">
                <div className="bg-surface border border-border rounded-2xl p-6">
                    <h2 className="text-base font-semibold text-ink mb-2">Partager DuckFlow</h2>
                    <p className="text-xs text-ink-muted mb-6">
                        Invitez vos amis et aidez-nous à grandir — choisissez une plateforme pour partager.
                    </p>

                    <div className="grid grid-cols-1 md:grid-cols-4 gap-3 mb-4">
                        <input
                            value={friendEmail}
                            onChange={(e) => setFriendEmail(e.target.value)}
                            placeholder="Email de votre ami"
                            className="col-span-3 px-3 py-2 border border-border rounded-lg text-sm bg-surface text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:border-accent"
                        />
                        <button
                            onClick={onInviteByEmail}
                            disabled={sending || !friendEmail}
                            className="bg-ink text-ink-inverse px-4 py-2 text-xs rounded-lg hover:bg-ink/90 transition-colors duration-150 disabled:opacity-40 disabled:cursor-not-allowed"
                        >
                            {sending ? 'Envoi…' : 'Envoyer'}
                        </button>
                    </div>

                    <div className="mb-4">
                        <button
                            onClick={copyLink}
                            className="bg-surface border border-border px-4 py-2 rounded-lg text-xs text-ink hover:bg-surface-sunken transition-colors duration-150"
                        >
                            {copied ? 'Copié !' : 'Copier le lien'}
                        </button>
                    </div>

                    <div className="text-xs text-ink-faint">
                        Nous suivons lorsque vous partagez afin de récompenser les parrainages et mesurer la croissance.
                    </div>
                </div>
            </div>
        </div>
    );
}
